export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [0];

export const dictionary = {
		"/": [2],
		"/about": [3],
		"/blog": [4],
		"/blog/3-invisible-leaks-costing-bgc-smes-10-hours-a-week": [5],
		"/blog/how-ai-is-reclaiming-hours-for-bgc-brokers": [6],
		"/blog/how-ecommerce-store-cut-support-tickets": [7],
		"/blog/how-modern-smes-using-ai-to-scale-operations": [8],
		"/blog/how-to-choose-automation-agency": [9],
		"/blog/is-your-business-ready-for-ai-automation": [10],
		"/blog/signs-business-losing-money-manual-processes": [11],
		"/blog/what-happens-when-you-automate-onboarding": [12],
		"/blog/what-is-business-process-automation": [13],
		"/blog/workflows-every-small-business-should-automate": [14],
		"/legal": [15],
		"/pricing": [~16],
		"/privacy": [17],
		"/solutions/ecommerce": [18],
		"/solutions/logistics": [19],
		"/solutions/real-estate": [20],
		"/solutions/saas": [21],
		"/thanks": [22],
		"/tools/automation-roi-calculator": [23]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';